module.exports = __webpack_public_path__ + "img/start_page_teen.d20c42bc.png";